import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { omit } from 'lodash-es';
import type { PropsWithChildren, RefAttributes, JSX } from 'react';

type ButtonActionOptionProps = DropdownMenu.DropdownMenuItemProps & RefAttributes<HTMLDivElement>;

export const ButtonActionOption = (props: PropsWithChildren<ButtonActionOptionProps>) => (
  <DropdownMenu.Item {...omit(props, 'children')} className="cursor-pointer tds-option-container-item tds-input-value tds-input-value-default">{props.children}</DropdownMenu.Item>
);

type ButtonActionWithMenuProps = {
  ButtonComponent: JSX.Element;
};

export const ButtonActionWithMenu = ({ ButtonComponent, children }: PropsWithChildren<ButtonActionWithMenuProps>) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        {ButtonComponent}
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="tds-option-container">
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
